module.exports = __webpack_public_path__ + "static/41fe9372557947c19a782ff2b218bc05542a3b8d8bab38c234af35068c1e0211-4b9ebb4817734337d81f6906f4399dcc.png";